import React, { useEffect } from 'react';
import { useNavigation } from 'context/NavigationContext';

const HighlightTarget = ({ id, children, className = '' }) => {
    const { checkAndHighlight } = useNavigation();

    useEffect(() => {
        checkAndHighlight();
    }, [checkAndHighlight]);

    return (
        <div id={id} data-highlight={id} className={`${className} overflow-visible`}>
            {children}
        </div>
    );
};

export default HighlightTarget;
